import { Br } from "@/components/molecules/Br";

const CareerIdeal = () => {
  return (
    <div id="ideal" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl px-8 font-bold md:px-20">
        <div className="relative z-10 flex flex-col gap-4 md:max-w-7xl md:gap-6">
          <div className="space-y-4 md:space-y-8">
            <div className="space-y-2">
              <h4 className=" text-ter fluid-text-[11px,16px]">
                理想とする人物像
              </h4>
              <h3 className=" text-ter fluid-text-[16px,22px] ">
                Ideal candidate profile
              </h3>
            </div>
            <h2 className=" text-pri fluid-text-[22px,45px]">IT が好き</h2>
          </div>
          <div className="space-y-2 leading-comfort text-txt-light fluid-text-[16px,21px] md:space-y-5 md:leading-loose">
            <div>
              私たちの求める人物像。エンジニアに必要なスキルは、プログラミングの技術だけではありません。
              <Br pc />
              モノを作り出すためには、クライアント様との間にコミュニケーション力が求められます。
              <Br pc />
              そして他者を思いやる想像力が大事です。まず相手の立場になって考えることができ、そしてなにより
              <Br tbpc />
              「Internet Technologyが好き」という人に出会いたいと考えています。
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerIdeal;
